<template>
  <div>
    <base-header class="pb-6 pb-8 pt-8 pt-md-5">
      <!-- Card stats -->
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="col-xl-8 order-xl-1">
            <card shadow>
              <template #header>
                <div class="border-0">
                  <div class="row align-items-center">
                    <div class="col-8 text-start">
                      <h5 v-if="!isUpdate" class="mb-0">{{ $t("New Request") }}</h5>
                      <h5 v-else class="mb-0">Update Request</h5>
                    </div>
                  </div>
                </div>
              </template>
              <form>
                <!--                <div class="text-start fw-bolder text-uppercase text-muted">Personal Details </div>-->
                <!--                <hr class="mt-0">-->
                <div class="text-start fw-bolder text-uppercase text-muted">
                  {{ normalizeGreek(userRole === 'system' ? $t("Client Details") : $t("Home Address")) }}
                </div>
                <hr class="mt-0">
                <div class="ps-lg-4">
                  <div v-if="userRole === 'system'" class="row">
                    <div class="col-lg-6">
                      <div class="form-group has-label" :class="{'has-danger': v$.model.clientId.$error }">
                        <label class="form-label">{{ $t("Select Client") }}</label>
                        <multiselect
                            v-model="model.clientId"
                            :show-labels="false"
                            label="name"
                            track-by="id"
                            :placeholder="$t('Select Client')"
                            :options="clients" :multiple="false"
                            :error="v$.model.clientId.$errors.map( err => { return err.$message })[0]"
                        ></multiselect>
                        <div v-if="v$.model.clientId.$invalid" class="text-danger invalid-feedback"
                             style="display: block;"
>
                          {{
                            v$.model.clientId.$errors.map(err => {
                              return err.$message
                            })[0]
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <base-input
                          v-model="model.address.street"
                          alternative=""
                          label="Address (Street & Number, Building Name, Floor, Flat No.)"
                          placeholder="Home Address"
                          input-classes="form-control-alternative"
                          :error="v$.model.address.street.$errors.map( err => { return err.$message })[0]"
                      />
                    </div>
                    <div class="col-lg-4">
                      <div class="form-group has-label" :class="{'has-danger': v$.model.address.city.$error }">
                        <label class="form-control-label">{{ $t('City') }}</label>

                        <multiselect
                            v-model="model.address.city"
                            :show-labels="false"
                            deselect-label="Can't remove this value"
                            placeholder="Select city"
                            :options="cities"
                            :searchable="false"
                            :custom-label="customCityLabel"
                        >
                        </multiselect>

                        <div v-if="v$.model.address.city.$error" class="text-danger invalid-feedback" style="display: block;">
                          {{ v$.model.address.city.$errors.map( err => { return err.$message })[0] }}
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <base-input
                          v-model="country"
                          disabled
                          alternative=""
                          :label="$t('Country')"
                          :placeholder="$t('Country')"
                          input-classes="form-control-alternative"
                      />
                    </div>
                    <div class="col-lg-4">
                      <base-input
                          v-model="model.address.postCode"
                          alternative=""
                          label="Post code"
                          placeholder="Post code"
                          input-classes="form-control-alternative"
                          :error="v$.model.address.postCode.$errors.map( err => { return err.$message })[0]"
                      />
                    </div>
                  </div>
                </div>
                <div class="text-start fw-bolder text-uppercase text-muted">{{ normalizeGreek($t("Request Details")) }}</div>
                <hr class="mt-0">
                <div class="ps-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group has-label" :class="{'has-danger': v$.model.serviceType.$error }">
                        <label class="form-label">{{ $t("Service type") }}</label>
                        <multiselect
                            v-model="model.serviceType"
                            :show-labels="false"
                            :placeholder="$t('Select type')"
                            :options="serviceTypes" :multiple="false"
                            :error="v$.model.serviceType.$errors.map( err => { return err.$message })[0]"
                        >
                          <template #singleLabel="{ option }">{{ $t(option) }}</template>
                          <template #option="props">
                            {{ $t(props.option) }}
                          </template>
                        </multiselect>
                        <div v-if="v$.model.serviceType.$invalid" class="text-danger invalid-feedback"
                             style="display: block;"
>
                          {{
                            v$.model.serviceType.$errors.map(err => {
                              return err.$message
                            })[0]
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group has-label" :class="{'has-danger': v$.model.employeeType.$error }">
                        <label class="form-label">{{ $t("Employee type") }}</label>
                        <multiselect
                            v-model="model.employeeType"
                            :show-labels="false"
                            :placeholder="$t('Select employee type')"
                            :options="employeeTypes" :multiple="false"
                            :error="v$.model.employeeType.$errors.map( err => { return err.$message })[0]"
                        >
                          <template #singleLabel="{ option }">{{ $t(option) }}</template>
                          <template #option="props">
                            {{ $t(props.option) }}
                          </template>
                        </multiselect>
                        <div v-if="v$.model.employeeType.$invalid" class="text-danger invalid-feedback"
                             style="display: block;"
>
                          {{
                            v$.model.employeeType.$errors.map(err => {
                              return err.$message
                            })[0]
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="ps-lg-4">
                  <div class="row">
                    <div v-if="['shift', 'service'].includes(model.serviceType)" class="col-lg-6">
                      <div class="form-group has-label" :class="{'has-danger': v$.model.shiftDate.$error }">
                        <label class="form-label">{{
                            $t(model.serviceType === "shift" ? "Live-in care date" : "Service Date")
                          }}</label>
                        <VueDatePicker
                            v-model="model.shiftDate"
                            :locale="$store.state.locale"
                            auto-apply
                            format="dd/MM/yyyy"
                            :flow="['calendar']"
                            :min-date="startOfToday"
                            :placeholder="$t(model.serviceType === 'shift' ? 'Live-in care date' : 'Service Date')"
                        ></VueDatePicker>
                        <div v-if="v$.model.shiftDate.$invalid" class="text-danger invalid-feedback"
                             style="display: block;"
>
                          {{
                            v$.model.shiftDate.$errors.map(err => {
                              return err.$message
                            })[0]
                          }}
                        </div>
                      </div>
                    </div>
                    <div v-if="['service'].includes(model.serviceType)" class="col-lg-6">
                      <div class="form-group has-label">
                        <label class="form-label">{{ $t("Preferable timeframe (optional)") }}</label>
                        <div class="row">
                          <div class="col-md-6">
                            <VueDatePicker
                                v-model="model.startTime"
                                :locale="$store.state.locale"
                                :select-text="$t('Select')"
                                :cancel-text="$t('Cancel')"
                                :start-time="{ hours: 10, minutes: 0 }"
                                minutes-increment="10"
                                minutes-grid-increment="10"
                                format="HH:mm"
                                time-picker
                                :flow="['time']"
                                :placeholder="$t('From')"
                            ></VueDatePicker>
                          </div>
                          <div class="col-md-6">
                            <VueDatePicker
                                v-model="model.endTime"
                                :locale="$store.state.locale"
                                :select-text="$t('Select')"
                                :cancel-text="$t('Cancel')"
                                :start-time="{ hours: 10, minutes: 0 }"
                                minutes-increment="10"
                                time-picker
                                minutes-grid-increment="10"
                                format="HH:mm"
                                :flow="['time']"
                                :placeholder="$t('To')"
                            ></VueDatePicker>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="model.serviceType === 'service'" class="col-lg-12">
                      <div class="form-group has-label" :class="{'has-danger': v$.model.serviceType.$error }">
                        <label class="form-label">{{ $t("Services") }}</label>
                        <multiselect
                            :show-labels="false"
                            :placeholder="$t('Add service')"
                            :options="services.filter(s => !model.services.map(m => m.id).includes(s.id))"
                            :multiple="false"
                            @select="addService"
                        >
                          <template #singleLabel="{ option }">{{ getTranslation(option.name, $store.state.locale) }}</template>

                          <template #option="props">
                            {{ getTranslation(props.option.name, $store.state.locale) }}
                          </template>
                        </multiselect>
                        <!--                        <div v-if="v$.model.serviceType.$invalid" class="text-danger invalid-feedback" style="display: block;">-->
                        <!--                          {{ v$.model.serviceType.$errors.map( err => { return err.$message })[0] }}-->
                        <!--                        </div>-->
                      </div>
                    </div>
                    <div v-if="model.serviceType === 'service' && model.services.length > 0" class="col-lg-12 table-responsive">
                      <table class="table">
                        <tr>
                          <th class="text-start">No</th>
                          <th class="text-start">Name</th>
                          <th></th>
                        </tr>
                        <tr v-for="(item, index) in model.services" :key="index" class="list-unstyled text-start">
                          <td>{{ index + 1 }}</td>
                          <td>{{ getTranslation(item.name, $store.state.locale) }}</td>
                          <td>
                            <button class="btn btn-outline-danger" @click="removeService(item)">
<i
                                class="fa fa-times"
></i>
</button>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div v-if="model.serviceType === 'shift'" class="col-lg-6">
                      <div class="form-group has-label" :class="{'has-danger': v$.model.shiftService.$error }">
                        <label class="form-label">{{ $t("Shift type") }}</label>
                        <multiselect
                            v-model="model.shiftService"
                            :show-labels="false"
                            :placeholder="$t('Select live-in care type')"
                            :options="services" :multiple="false"
                        >
                          <template #singleLabel="{ option }">{{ option.name.en }}</template>
                          <template #option="props">
                            {{ props.option.name.en }}
                          </template>
                        </multiselect>
                        <!--                        <div v-if="v$.model.serviceType.$invalid" class="text-danger invalid-feedback" style="display: block;">-->
                        <!--                          {{ v$.model.serviceType.$errors.map( err => { return err.$message })[0] }}-->
                        <!--                        </div>-->
                      </div>
                    </div>
                    <div
                        v-if="model.serviceType === 'shift' && model.shiftService != null && model.shiftService.timeSlots.length > 0"
                        class="col-lg-6"
>
                      <div class="form-group has-label" :class="{'has-danger': v$.model.shiftSlot.$error }">
                        <label class="form-label">{{ $t("Timeslot") }}</label>
                        <multiselect
                            v-model="model.shiftSlot"
                            :show-labels="false"
                            :placeholder="$t('Select timeslot')"
                            :options="model.shiftService.timeSlots" :multiple="false"
                        >
                          <template #singleLabel="{ option }">
                            {{ option.startTime }} - {{ option.endTime }} ({{ option.priceInCents / 100 + '€' }})
                          </template>
                          <template #option="props">
                            {{ props.option.startTime }} - {{ props.option.endTime }}
                            ({{ props.option.priceInCents / 100 + '€' }})
                          </template>
                        </multiselect>
                        <!--                        <div v-if="v$.model.serviceType.$invalid" class="text-danger invalid-feedback" style="display: block;">-->
                        <!--                          {{ v$.model.serviceType.$errors.map( err => { return err.$message })[0] }}-->
                        <!--                        </div>-->
                      </div>
                    </div>
                    <!--                    <div v-if="model.startDate > new Date()" class="col-md-12">-->
                    <!--                      <div class="text-start pt-0 pb-4 text-black-50">-->
                    <!--                        <label><b>* {{ $t("Claim deadline") }}</b> {{ $t("is the latest time by which a request can be claimed.") }}</label>-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                    <!--                  <div v-if="model.startDate < new Date() && userRole === 'system'" class="col-md-12">-->
                    <!--                    <div class="form-group has-label" :class="{'has-danger': v$.model.buyerId.$error }">-->
                    <!--                      <label class="form-label">{{ $t("Partner to assign shift") }}</label>-->
                    <!--                      <multiselect-->
                    <!--                          v-model="model.buyerId"-->
                    <!--                          :show-labels="false"-->
                    <!--                          label="name"-->
                    <!--                          track-by="id"-->
                    <!--                          :placeholder="$t('Select Partner')"-->
                    <!--                          :options="employees" :multiple="false"-->
                    <!--                      ></multiselect>-->
                    <!--                      <div v-if="v$.model.buyerId.$invalid" class="text-danger invalid-feedback" style="display: block;">-->
                    <!--                        {{ v$.model.buyerId.$errors.map( err => { return err.$message })[0] }}-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                    <!--                  </div>-->
                    <div class="col-lg-6">
                      <div class="form-group has-label" :class="{'has-danger': v$.model.preferredPaymentMethod.$error }">
                        <label class="form-label">{{ $t("Preferred payment method") }}</label>
                        <multiselect
                            v-model="model.preferredPaymentMethod"
                            :show-labels="false"
                            :placeholder="$t('Select payment method')"
                            :options="['cash', 'card']" :multiple="false"
                        >
                          <template #singleLabel="{ option }">
                            {{ $t(option) }}
                          </template>
                          <template #option="props">
                            {{ $t(props.option) }}
                          </template>
                        </multiselect>
                        <div v-if="v$.model.preferredPaymentMethod.$invalid" class="text-danger invalid-feedback" style="display: block;">
                          {{ v$.model.preferredPaymentMethod.$errors.map( err => { return err.$message })[0] }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group has-label" :class="{'has-danger': v$.model.gender.$error }">
                        <label class="form-label">{{ $t("Preferred gender") }} </label>
                        <multiselect
                            v-model="model.gender"
                            :show-labels="false"
                            :placeholder="$t('Select gender')"
                            :options="['noPref', 'male', 'female']"
                        >
                          <template #singleLabel="{ option }">{{ $t(option ?? '') }}</template>
                          <template #option="props">
                            {{ $t(props.option ?? '') }}
                          </template>
                        </multiselect>
                        <div v-if="v$.model.gender.$invalid" class="text-danger invalid-feedback" style="display: block;">
                          {{ v$.model.gender.$errors.map( err => { return err.$message })[0] }}
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-group has-label">
                        <label class="form-label">{{ $t("Notes") }}</label>
                        <base-input>
                            <textarea
                                v-model="model.notes"
                                rows="4"
                                class="form-control form-control-alternative"
                                placeholder=""
                            >
                            </textarea>
                        </base-input>
</div>
                    </div>
                  </div>
                </div>

                <div class="text-start fw-bolder text-uppercase text-muted">{{ $t("Request Cost") }}</div>
                <hr class="mt-0">
                <div class="ps-lg-4">
                  <div class="row">
                    <label v-if="!requestCost" class="text-start float-start">{{
                        $t("Cost cannot be calculated yet.")
                      }}</label>
                    <label v-if="userRole === 'client' && requestCost" class="text-start float-start fw-bold">
                      {{ $t("The total cost is to be paid directly to the professional attending to your service.") }}
                    </label>
                    <div class="col-md-4 pt-2">
                      <display-label
                          label="Total cost:"
                          :value="model.cost.totalCost == null ? '€' : model.cost.totalCost/100+'€'"
                      ></display-label>
                    </div>
                    <div v-if="userRole !== 'client'" class="col-md-4 pt-2">
                      <display-label
                          label="Employee earnings:"
                          :value="model.cost.employeeEarnings == null ? '€' : model.cost.employeeEarnings/100+'€'"
                      ></display-label>
                    </div>
                    <div v-if="userRole !== 'client'" class="col-md-4 pt-2">
                      <display-label
                          label="Company commission:"
                          :value="model.cost.companyCommission == null ? '€' : model.cost.companyCommission/100+'€'"
                      ></display-label>
                    </div>
                  </div>
                </div>
                <!--                <div class="text-start fw-bolder text-uppercase text-muted">Documents </div>-->
                <!--                <hr class="mt-0">-->
                <!--                <div class="ps-lg-4">-->
                <!--                  <div class="row"></div>-->
                <!--                </div>-->
                <div class="col-12 text-end">
                  <base-button v-if="!isUpdate" class="me-2" outline type="info" @click="clearForm">
{{
                      $t("Reset")
                    }}
                  </base-button>
                  <submit-button :alert-message="errorMessage" :state="loadingProcess" @clicked="submit">
                    {{ $t(isUpdate ? 'Update' : 'Submit') }}
                  </submit-button>
                </div>
              </form>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FirebaseFunctionsHelper from "@/helpers/firebaseFunctionsHelper"
import useVuelidate from "@vuelidate/core"
import {helpers, maxLength, maxValue, minLength, minValue, required, requiredIf} from "@vuelidate/validators"
import DisplayLabel from "@/components/DisplayLabel.vue"
import {calculateRequestCost} from "@/helpers/shiftCostCalculator"
import {getTranslation, normalizeGreek, toCents} from "@/helpers/common"
import BaseInput from "@/components/BaseInput.vue"
//
// const maxIfNotEmpty = (param) => helpers.withParams(
//     { type: "maxIfNotEmpty", value: param }, (value) => {
//
//       if (param == null || param === "" || value == null || value === ""){
//         return true
//       }
//
//       return param < value
//     })
export default {
  name: "RequestForm",
  components: {BaseInput, DisplayLabel},
  setup: () => ({v$: useVuelidate()}),
  data() {
    return {
      cities: ["LIMASSOL", "NICOSIA", "LARNACA", "PAPHOS", "AMOCHOSTOS"],
      clientConfigs: null,
      refreshKey: 1,
      clients: [],
      country: "Cyprus",
      services: [],
      employees: [],
      isUpdate: false,
      errorMessage: "",
      loadingProcess: "",
      loadingMessage: "",
      model: {
        // requestStatus: {id: "PENDING", name: this.$t("Pending")},
        clientId: null,
        preferredPaymentMethod: null,
        serviceType: null,
        buyerId: null,
        shiftDate: null,
        notes: null,
        endTime: null,
        employeeType: null,
        startTime: null,
        // shiftService: {name: {en:"",gr:""}, timeSlots: []},
        shiftService: null,
        shiftSlot: null,
        gender: "noPref",
        services: [],
        address: {
          street: "",
          city: "",
          postCode: "",
          locality: "",
          countryCode: "CY",
        },
        cost: {
          totalCost: null,
          employeeEarnings: null,
          companyCommission: null,
        }
      }

    }
  },
  validations() {
    return {
      model: {
        address: {
          street: {
            required: helpers.withMessage(this.$t("Value is required"), required)
          },
          city: {
            required: helpers.withMessage(this.$t("Value is required"), required)
          },
          postCode: {
            required: helpers.withMessage(this.$t("Value is required"), required),
            minLength: minLength(4),
            maxLength: maxLength(4),
          },
        },
        clientId: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        gender: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        preferredPaymentMethod: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        shiftDate: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        shiftSlot: {
          requiredIf: helpers.withMessage(this.$t("Value is required"), requiredIf(this.model.serviceType === "shift"))
        },
        // startDate: {
        //   requiredIf: helpers.withMessage(this.$t("Value is required"), requiredIf(this.model.serviceType === "service")),
        //  // maxValue: maxValue(this.model.endDate),
        //  // maxIfNotEmpty: helpers.withMessage("The maximum value allowed is "+ this.$moment(this.model.endDate).format(), maxIfNotEmpty(this.model.endDate))
        // },
        // endDate: {
        //   requiredIf: helpers.withMessage(this.$t("Value is required"), requiredIf(this.model.serviceType === "service")),
        //   minValue: minValue(this.model.startDate),
        // },
        shiftService: {
          requiredIf: helpers.withMessage(this.$t("Value is required"), requiredIf(this.model.serviceType === "shift"))
        },
        serviceType: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        employeeType: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        buyerId: {
          requiredIf: helpers.withMessage(this.$t("Value is required"), requiredIf(() => this.isBeforeToday(this.model.shiftDate)))
        }
      },
    }
  },
  computed: {
    startOfToday() {
      return this.$moment().startOf("day").toDate()
    },
    serviceTypes() {
      return ["shift", "service"].filter(option => {
        if (this.model.employeeType === "doctor") {
          return option === "service"
        } else if (this.model.serviceType === "nurse") {
          return true // Keep both options
        } else {
          return true
        }
      })
    },
    employeeTypes() {
      return ["nurse", "doctor", "physiotherapist"].filter(option => {
        if (this.model.serviceType === "shift") {
          return option === "nurse"
        } else if (this.model.serviceType === "service") {
          return true // Keep both options
        } else {
          return true
        }
      })
    },
    userRole() {
      return this.$store.state.user?.claims?.role ?? null
    },
    requestCost() {
      if (this.model.serviceType == null ||
          this.model.employeeType == null ||
          this.model.shiftDate == null ||
          (this.model.serviceType === "shift" && (this.model.shiftService == null || this.model.shiftSlot == null)) ||
          (this.model.serviceType === "service" && this.model.services.length === 0) ||
          this.clientConfigs == null) {
        return false
      }

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.model.cost = calculateRequestCost(
          this.clientConfigs,
          this.model.serviceType === "shift" ? [{timeSlot: this.model.shiftSlot}] : this.model.services,
          this.model.serviceType,
          this.model.employeeType
      )
      console.log("this.model.cost", this.model.cost)
      return true
    }
  },
  watch: {
    "model.serviceType": function (newValue) {
      console.log("model.serviceType", newValue)
      if (newValue == null) {
        return
      }
      this.getServices(newValue, this.model.employeeType)
    },
    "model.employeeType": function (newValue) {
      console.log("model.employeeType", newValue)
      if (newValue == null) {
        return
      }
      this.getServices(this.model.serviceType, newValue)
    },
    "model.shiftDate": function (newValue) {
      console.log("model.shiftDate newValue", newValue)

      if (newValue !== null && this.isBeforeToday(newValue)) {
        this.getEmployees()
      }

      if (this.model.endDate == null) {
        this.model.endDate = this.$moment(newValue).add("8", "hours").toDate()
      }
    },
    "model.clientId": async function (client) {
      console.log("model.clientId", client)
      if (client) {
        await this.getSettings(client.id)
      }
    },
  },
  async mounted() {
    console.log("this.$store.state.user.claims", this.$store.state.user.claims)
    if (this.userRole === "system") {
      await this.getClients()
    } else {
      console.log("getSettings getSettings getSettings")
      this.model.clientId = { id: this.$store.state.user.claims.user_id}
      await this.getSettings(this.$store.state.user.claims.user_id)
    }
    if (this.$route.params.hasOwnProperty("id")) {
      this.isUpdate = true
      console.log("getRequest getRequest getRequest")
      await this.getRequest()
    }
  },
  methods: {
    getTranslation,
    normalizeGreek,
    isBeforeToday(date) {
      if (date == null) {
        return false
      }

      return this.$moment(date).startOf("day").isBefore(this.$moment().startOf("day"))
    },
    removeService(service) {
      this.model.services.splice(this.model.services.indexOf(service), 1)
    },
    customCityLabel(option) {
      return this.$t(option)
    },
    addService(service) {
      console.log("service", service)
      console.log("this.model.services", this.model.services)
      this.model.services.push(service)
    },
    async getEmployees() {
      if (this.employees.length === 0) {
        await this.$store.dispatch("fetchEmployees", {limit: 200}).then((data) => {
          console.log("fetchEmployees", data)
          this.employees = data.data
        })
      }
    },
    async getSettings(id) {
      const clientSettings = await this.$store.dispatch("fetchClient", id)
      console.log("clientSettings id", id)
      console.log("clientSettings", clientSettings)
      if (!clientSettings.hasOwnProperty("configs") || clientSettings.configs == null) {
        this.clientConfigs = await this.$store.dispatch("fetchSettings")
      } else {
        this.clientConfigs = clientSettings.configs
      }
      console.log("this.clientConfigs", this.clientConfigs)

      const client = await this.$store.dispatch("fetchClient", id)

      if (Object.hasOwn(client, "address")) {
        this.model.address = client["address"]
      }
    },
    async getClients() {
      await this.$store.dispatch("fetchClients").then((data) => {
        // console.log("fetchClients", data)
        this.clients = data
      })
    },
    async getServices(serviceType, employeeType) {
      if (serviceType == null || employeeType == null) {
        return
      }
      this.model.services = []
      this.services = []
      this.services = await this.$store.dispatch("fetchAllServices", {type: serviceType, employeeType: employeeType})
      console.log("servicessssss", this.services)


      if (this.services.length === 1) {
        this.addService(this.services[0])
      }
      // if (this.userRole === "system") {
      //     this.allServices = allServices
      // } else {
      // await this.$store.dispatch("fetchClient", this.$store.state.user.claims.clientId).then((data) => {
      //   console.log("fetchClient fetchClient", data)
      //   if (data.hasOwnProperty("name")) {
      //     this.model.clientId = {id: this.$store.state.user.claims.clientId, name: data.name}
      //   }
      //   if (data.hasOwnProperty("positionIds")){
      //     data.positionIds.forEach( p => {
      //
      //       let selected = allPositions.find(pos => pos.id === p)
      //
      //       console.log("allPositions selected", selected)
      //       if (selected ?? false) {
      //         console.log("allPositions selected got it")
      //         this.positions.push(selected)
      //       }
      //     })
      //   }
      // })
      // }
    },
    async getRequest() {
      const data = await this.$store.dispatch("fetchRequest", this.$route.params.id)

      let selectedPositions = []
      data.forEach(positionsId => {
        let selected = this.positions.find(pos => pos.key === positionsId)
        if (selected) {
          selectedPositions.push(selected)
        }
      })

      this.model = data
      this.model.positionIds = selectedPositions
    },
    async submit() {
      let self = this

      this.v$.$touch()

      if (this.v$.model.$invalid) {
        console.log(this.v$.$errors)
        return
      }

      let request = JSON.parse(JSON.stringify(this.model))
      let payload = {
        clientId: request.clientId.id,
        employeeType: request.employeeType,
        serviceType: request.serviceType,
        notes: this.model.notes,
        cost: request.cost,
        gender: request.gender,
        address: request.address,
        preferredPaymentMethod: request.preferredPaymentMethod
      }

      if (request.serviceType === "shift") {

        payload["services"] = [{
          id: request.shiftService.id,
          priceInCents: request.shiftService.priceInCents,
          timeSlot: request.shiftSlot
        }]

        const startTime = request.shiftSlot.startTime.split(":")
        const endTime = request.shiftSlot.endTime.split(":")
        console.log("startTime", endTime)
        console.log("request.shiftDate ", request.shiftDate)
        payload["startDate"] = this.$moment(request.shiftDate).set({
          hour: startTime[0],
          minute: startTime[1],
          second: 0
        }).toDate()

        let startDate = this.$moment(request.shiftDate).set({hour: endTime[0], minute: endTime[1], second: 0})
        if (startTime[0] > endTime[0]) {
          startDate = startDate.add(1, "day")
        }
        payload["endDate"] = startDate.toDate()
      } else {
        var startDate = this.$moment(request.shiftDate).set({hour: 0, minute: 0, second: 0})
        if (request.startTime) {
          const startTime = this.$moment(request.startTime)
          console.log("startTime hours", startTime.hours())
          console.log("startTime minutes", startTime.minutes())
          startDate = startDate.set({hour: startTime.hours(), minute: startTime.minutes(), second: 0}).toDate()
        } else {
          console.log("startDate", startDate)
          startDate = startDate.toDate()
        }

        var endDate = this.$moment(request.shiftDate)
        if (request.endTime) {
          const endTime = this.$moment(request.endTime)
          endDate = endDate.set({hour: endTime.hours(), minute: endTime.minutes(), second: 0}).toDate()
        } else {
          endDate = endDate.set({hour: 23, minute: 59, second: 59})
          endDate = endDate.toDate()
        }


        payload["startDate"] = startDate
        payload["endDate"] = endDate

        payload["services"] = request.services.map((service) => {
          return {
            id: service.id,
            priceInCents: service.priceInCents,
          }
        })
      }

      console.log("payload", payload)

      this.loadingProcess = "processing"
      FirebaseFunctionsHelper.callFunction(
          "request-create",
          // eslint-disable-next-line no-undef
          payload
      )
          .then((result) => {
            console.log("res", result)
            // eslint-disable-next-line no-prototype-builtins
            if (result != null && result.hasOwnProperty("message")) {
              console.log("result message", result.message)
              self.loadingProcess = "failed"
              self.errorMessage = result.message
              return
            }
            console.log("submitUser result", result)
            this.loadingProcess = "done"
            this.$router.push({path: "/requests/" + result})

          })
          .catch((error) => {
            self.loadingProcess = "failed"
            self.errorMessage = error.message
            console.log("submitUser error", error)
          })

      // setTimeout(() => {
      //   this.loadingProcess = "failed";
      //   this.loadingMessage = "There was an error.";
      //   //Add Tokens
      // }, 2000);
    },
    clearForm() {
      this.loadingProcess = ""
      this.model.clientId = null

      this.model.preferredPaymentMethod = null
      this.model.serviceType = null
      this.model.buyerId = null
      this.model.shiftDate = null
      this.model.notes = null
      this.model.endTime = null
      this.model.employeeType = null
      this.model.startTime = null
      this.model.shiftService = null
      this.model.shiftSlot = null
      this.model.gender = "noPref"
      this.model.services = []
      this.model.address = {
          street: "",
          city: "",
          postCode: "",
          locality: "",
          countryCode: "CY"
      }
      this.model.cost = {
          totalCost: null,
          employeeEarnings: null,
          companyCommission: null,
      }

      if (this.userRole !== "system") {
        this.model.clientId = {id: this.$store.state.user.claims.user_id}
      }
    },
  },
}
</script>
<style scoped>
.form-group.has-label {
  padding-top: 0.5rem !important;
}
</style>
